import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full align-content-center font-bold justify-content-between" }
const _hoisted_2 = { class: "align-content-center" }
const _hoisted_3 = { class: "py-1 surface-100 border-round-xl flex gap-2 align-items-center justify-content-end" }

import { OverageListInterface } from '@/types';
import { toRefs } from 'vue';
import SeatChip from './SeatChip.vue';

interface Props {
  overage: OverageListInterface;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SeatsPerDisciplineHeader',
  props: {
    overage: {}
  },
  setup(__props: any) {

const props = __props;

const { overage } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(overage).discipline.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SeatChip, {
        title: "Contracted",
        "text-color": "text-color-black",
        text: _unref(overage).seats
      }, null, 8, ["text"]),
      _createVNode(SeatChip, {
        title: "Total",
        "text-color": "text-color-red",
        text: _unref(overage).completed_count + _unref(overage).scheduled_count
      }, null, 8, ["text"]),
      _createVNode(SeatChip, {
        title: "Completed",
        "text-color": "text-color-blue",
        text: _unref(overage).completed_count
      }, null, 8, ["text"]),
      _createVNode(SeatChip, {
        title: "Scheduled",
        "text-color": "text-color-orange",
        text: _unref(overage).scheduled_count
      }, null, 8, ["text"])
    ])
  ]))
}
}

})